export default "__VITE_ASSET__900a9d4f__"